import { Schema, normalize, arrayOf } from 'normalizr'
import { receiveComments } from '@actions/comment_actions.js'
import { receiveUsers } from '@actions/user_actions.js'

export function handleFetchTimelineCommentsSuccess(res) {
  return (dispatch, getState) => {
    const parsedJSON = res.data

    const comment = new Schema('comments')
    const user = new Schema('users')
    comment.define({
      user,
    })
    const normalized = normalize(parsedJSON, {
      comments: arrayOf(comment),
      users: arrayOf(user),
    })

    // first put the user into state, then the comments
    dispatch(receiveUsers(normalized.entities.users))
    dispatch(receiveComments(normalized.entities.comments))
  }
}
